"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const theme = {
    breakpoints: ["40em", "64em", "80em"],
    colors: {
        text: "#0C1421",
        muted: "#758398",
        background: "#FFFFFF",
        border: "#D3DEE9",
        primary: "#194EC0",
        secondary: "#058C78",
        tertiary: "#133FA0",
        success: "#33B679",
        cancel: "#DB4332",
        gray: [
            "#EEEEEE",
            "#D3DEE9",
            "#79879D",
            "#758398",
            "#5B6268",
            "#0C1421",
        ],
        blue: ["#BBE1FA", "#3282B8", "#0F4C75", "#1B262C"],
        orange: ["#FFAD6E", "#F0924A", "#E1731E", "#B15813", "#8F3F01"],
        green: ["#ABDD93", "#7AB85C", "#519331", "#306E12", "#184A00"],
        red: ["#FFACAA", "#EC7976", "#C92420", "#A0110D", "#590200"],
        yellow: "#FFC82C",
        white: "#FFFFFF",
    },
    fonts: {
        body: "'Open-sans', sans-serif",
        heading: "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif",
    },
    fontSizes: [12, 14, 16, 20, 24, 32, 48],
    fontWeights: {
        body: 400,
        heading: 700,
        bold: 700,
    },
    lineHeights: {
        body: 1.5,
        heading: 1.125,
    },
    mediaQueries: {},
    radii: [0, 4, 8, 16],
    space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
};
exports.theme = theme;
theme.space.xsmall = theme.space[1] + "px";
theme.space.small = theme.space[2] + "px";
theme.space.medium = theme.space[3] + "px";
theme.space.large = theme.space[4] + "px";
theme.space.xlarge = theme.space[5] + "px";
theme.mediaQueries = {
    small: `@media screen and (min-width: ${theme.breakpoints[0]})`,
    medium: `@media screen and (min-width: ${theme.breakpoints[1]})`,
    large: `@media screen and (min-width: ${theme.breakpoints[2]})`,
};
